import { render, staticRenderFns } from "./RoleToCreate.vue?vue&type=template&id=e4de761c&scoped=true&"
import script from "./RoleToCreate.vue?vue&type=script&lang=js&"
export * from "./RoleToCreate.vue?vue&type=script&lang=js&"
import style0 from "./RoleToCreate.vue?vue&type=style&index=0&id=e4de761c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4de761c",
  null
  
)

export default component.exports